<template>
    <div v-if='account_status'>
        <div id='forgotten-page-container' class='container-fluid page'>
            <div class='row'>
                <div class='col-sm-8 col-md-6 col-lg-4 mx-auto'>
                    <div class='card card-signin my-5'>
                        <div class='card-body'>
                            <h5 class='card-title text-center'><span class='icon-lock'></span> Changement de mot de
                                passe</h5>
                            <form novalidate action='#' @submit.prevent='changePassword'>
                                <div class='form-group row' style='min-height:60px'>
                                    <div class='col-sm-12 input-group'>
                                        <input :type='passwordFieldType' v-model='password' class='form-control'
                                               id='password'
                                               placeholder='Entrez votre mot de passe'
                                               onfocus='this.placeholder=""'
                                               onblur="this.placeholder='Entrez votre mot de passe'"
                                               :class="[{'form-control':true, 'is-invalid' : !validPassword(password) && blur_password},{'form-control':true, 'is-valid' : validPassword(password) && blur_password}]"
                                               v-on:blur='blur_password = true'/>
                                        <div class='input-group-append' @mousedown='showPasswords'
                                             @mouseup='hidePasswords' style='max-height: 38px;'>
                                            <span class='input-group-text'><span class='icon-eye'></span></span>
                                        </div>
                                        <div class='invalid-feedback'>
                                            {{ error_password }}
                                        </div>
                                        <div class='valid-feedback'>
                                            Mot de passe valide.
                                        </div>
                                    </div>
                                </div>
                                <div class='form-group row' style='min-height:60px;'>
                                    <div class='col-sm-12 input-group'>
                                        <input :type='passwordFieldType' v-model='password_confirmation'
                                               class='form-control' id='password_confirmation'
                                               placeholder='Confirmez votre mot de passe'
                                               onfocus='this.placeholder=""'
                                               onblur="this.placeholder='Confirmez votre mot de passe'"
                                               :class="[{'form-control':true, 'is-invalid' : !validPasswordConfirmation(password_confirmation) && blur_password_confirmation},{'form-control':true, 'is-valid' : validPasswordConfirmation(password_confirmation) && blur_password_confirmation}]"
                                               v-on:blur='blur_password_confirmation = true'/>
                                        <div class='input-group-append' @mousedown='showPasswords'
                                             @mouseup='hidePasswords' style='max-height: 38px;'>
                                            <span class='input-group-text'><span class='icon-eye'></span></span>
                                        </div>
                                        <div class='invalid-feedback'>
                                            {{ error_password_confirmation}}
                                        </div>
                                        <div class='valid-feedback'>
                                            Mots de passe identiques.
                                        </div>
                                    </div>
                                </div>
                                <div class='form-group row'>
                                    <div class='col-sm-12 input-group'>
                                        <button class='btn btn-lg btn-primary btn-block text-uppercase' type='submit'>
                                            <span class='icon-signin'></span> Valider
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div id='loader-container'>
                                <PulseLoader :loading='loading' :color='color' :size='size'></PulseLoader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='row pt-2 mx-auto'>
                <div class='col-3 mx-auto' style='text-align: center;'>
                    <a :href='user_manual_link' target='_blank'><span class='icon-book'></span> Manuel utilisateur</a>
                </div>
            </div>
        </div>
    </div>
    <information-content @redirect='redirectLogin' v-else>
        <template slot='title'>
            Votre compte n'a pas pu être trouvé.<br> Merci de prendre contact avec le support de l'ADEC.
        </template>
        <template slot='label'>
            SE CONNECTER
        </template>
    </information-content>
</template>

<script>
    import InformationContent from '../components/layout/InformationContent';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        components: {
            InformationContent,
            PulseLoader
        },
        name: 'change-password',
        data: function () {
            return {
                user_manual_link: 'src/public/doc/Credicys - documentation utilisateur non connecte.pdf?' + Date.now(),
                account_status: false,
                //PulseLoader props
                loading: false,
                color: '#d93752',
                size: '1em',
                // Form props
                passwordFieldType: 'password',

                password: '',
                valid_password: false,
                error_password: '',
                blur_password: false,

                password_confirmation: '',
                valid_password_confirmation: false,
                error_password_confirmation: '',
                blur_password_confirmation: false,
            }
        },
        computed: {
            valid: function () {
                return this.valid_password && this.valid_password_confirmation;
            }
        },
        methods: {
            validate: function () {
                this.blur_password = true;
                this.blur_password_confirmation = true;
                if (this.validPassword(this.password)) {
                    this.valid_password = true;
                } else {
                    this.valid_password = false;
                }
                if (this.validPasswordConfirmation(this.password_confirmation)) {
                    this.valid_password_confirmation = true;
                } else {
                    this.valid_password_confirmation = false;
                }
            },
            checkTokenPassword: function () {
                this.loading = true;
                this.$store.dispatch('postApi', {
                    'controller':'PCAuth',
                    'action':'checkTokenPassword',
                    'post': {
                        token: this.$route.params.token,
                    }
                })
                    .then(response => {
                    this.loading = false;
                    if (response.data.error === 'auth_not_found') {
                        this.account_status = false
                    } else {
                        this.account_status = true
                    }
                })
            },
            validPassword: function (password) {
                if (this.password.trim().length == 0) {
                    this.error_password = 'Merci de renseigner un mot de passe.'
                    return false;
                }
                if (this.password.trim().length < 8) {
                    this.error_password = 'Votre mot de passe doit contenir au moins 8 caractères.'
                    return false;
                }
                return true;
            },
            validPasswordConfirmation: function (password_confirmation) {
                if (this.password.trim().length == 0) {
                    this.error_password_confirmation = 'Merci de renseigner un mot de passe.'
                    return false;
                } else if (this.password_confirmation.trim().length == 0) {
                    this.error_password_confirmation = 'Merci de confirmer votre mot de passe.'
                    return false;
                } else if (password_confirmation !== this.password) {
                    this.error_password_confirmation = 'Les mots de passe ne sont pas identiques.'
                    return false;
                }
                return true;
            },
            showPasswords: function () {
                this.passwordFieldType = 'text'
            },
            hidePasswords: function () {
                this.passwordFieldType = 'password'
            },
            redirectLogin: function (event) {
                this.$router.push({name: 'login'});
            },
            changePassword() {
                this.validate();
                if (this.valid) {
                    this.loading = true;
                    this.$store.dispatch('postApi', {
                        'controller':'PCAuth',
                        'action':'changePassword',
                        'post': {
                            password: this.password,
                            token: this.$route.params.token
                        }
                    }).then(response => {
                        this.loading = false;
                        this.$router.push({name: 'change-password-success'});
                    })
                }
            }
        },
        beforeMount() {
            this.checkTokenPassword()
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/ChangePassword.vue